import styled from 'styled-components';
import {colors, shadows} from '../../styleVariables';

export const Header = styled.div.attrs({className: 'drag-handle'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ListStyle = styled.div`
  position: absolute;
  bottom: 2rem;
  background: white;
  width: calc(100% - 3rem);
  border-radius: 12px;
  padding: 1rem;

  ${Header} {
    h5 {
      color: ${({theme}) => theme};
    }
  }

  thead tr th {
    background-color: white;
    box-shadow: ${shadows.shadow};
    border-top: 1px solid ${colors.gray5};
    border-bottom: 1px solid ${colors.gray5};
    color: ${({theme}) => theme};
    font-weight: bold;
    height: 3.125rem;
    padding: 0.75rem 1.25rem;
    text-align: left;
    white-space: nowrap;
    font-size: 0.8rem;
  }

  thead tr th:first-child {
    border-left: 1px solid ${colors.gray5};
    border-top-left-radius: 12px;
  }

  thead tr th:last-child {
    border-right: 1px solid ${colors.gray5};
    border-top-right-radius: 12px;
  }

  // tbody {
  //   overflow-y: auto;
  //   max-height: 150px;
  // }

  // tr {
  //   display: flex;

  //   th,
  //   td {
  //     padding: 1.1rem 1.5rem;

  //     &:nth-child(1) {
  //       width: 40%;
  //     }

  //     &:nth-child(2) {
  //       width: 40%;
  //     }

  //     &:nth-child(3) {
  //       width: 20%;
  //     }
  //   }
  // }
`;
